import Reveal from "@/components/Reveal";
import { ShieldCheck, Zap, Users, Lock } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, title: "Results Driven", body: "We focus on real growth and measurable results." },
  { icon: Zap, title: "Fast Delivery", body: "Quick turnaround and on-time campaign delivery." },
  { icon: Users, title: "Expert Team", body: "Industry experts with years of marketing experience." },
  { icon: Lock, title: "100% Secure", body: "Your information and campaigns are always safe." },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative border-t border-[#1F1F1F] bg-[#050505] py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#E11D2E]">Why choose us</p>
        </Reveal>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <Reveal key={item.title} delay={i * 0.08} data-testid={`why-item-${i}`}>
              <div className="group border-t-2 border-[#1F1F1F] pt-6 transition-colors duration-500 hover:border-[#E11D2E]">
                <item.icon size={26} className="text-[#E11D2E]" />
                <h3 className="mt-4 font-display text-base uppercase tracking-wide text-white">{item.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-[#8A8A8A]">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
